import { AppConfig } from 'src/app/core/_config/app.config';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchTypeEnum } from './search-person-input.component';


@Injectable({
  providedIn: 'root'
})
export class SearchPersonInputService {

  private API_URL = this.config.urlApi + this.config.versionApi;

  constructor(
    private http: HttpClient,
    private config: AppConfig) { }

  getPerson(name: string, type: SearchTypeEnum) {
    var query = {
      params: {
        personName: `${name}`,
      }
    };

    switch (type) {
      case SearchTypeEnum.PersonContract:
        return this.getPersonContractByName(query);

      case SearchTypeEnum.PersonDocument:
        return this.getPersonDocumentByName(query);
    }
  }

  getPersonDocumentByName(params: any): Observable<any> {
    return this.http.get(`${this.API_URL}Person`, params);
  }

  getPersonContractByName(params: any): Observable<any> {
    return this.http.get(`${this.API_URL}Management/Person`, params);
  }
}
